angular.module("app").controller("PagesListBackgroundController", [
    '$scope',
    '$cookies',
    '$rootScope',
    '$timeout',
    'preloadedPages',
    'pagesService',
    'errorHandler',
    'typeToLoad',
    'logger',
    'settingsService',
    'preloadedPageNames',
    'backgroundPageDefaults',
    'backgroundAttachment',
    'Utils',
    function ($scope, $cookies, $rootScope, $timeout, preloadedPages, pagesService, errorHandler, typeToLoad, logger, settingsService, preloadedPageNames, backgroundPageDefaults, backgroundAttachment, Utils) {
        var settings = settingsService.getSettings();
        $scope.backgroundAttachment = backgroundAttachment;
        $scope.selectedLanguage = $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang;
        $scope.addedMenus = {};
        var initialData;
        $scope.addingMenuName = "";
        $scope.languages = settings.skin.languages;
        var pageNameTitleMap = {};
        var reversedBackgroundSize = Utils.createReverse(backgroundPageDefaults.backgroundSize);

        /**
         * Init page names
         */
        function initPageNames(pageNamesPrsponse) {
            $scope.pageNames = angular.copy(pageNamesPrsponse.pageNames);
            $scope.usedPageNames = {};
            pageNameTitleMap = {};
            var pageNamesLength = $scope.pageNames.length;
            for(var j = 0; j < pageNamesLength; ++j){
                var pageName =  $scope.pageNames[j];
                pageNameTitleMap[pageName.name] = pageName.title;
                if (pageNamesPrsponse.used.indexOf(pageName.id) !== -1){
                    $scope.usedPageNames[pageName.id] = true;
                }
                if ($scope.addedMenus[$scope.selectedLanguage]) {
                    var addedMenusLength = $scope.addedMenus[$scope.selectedLanguage].length;
                    for(var i = 0; i < addedMenusLength; ++i){
                        var addedPageName = $scope.addedMenus[$scope.selectedLanguage][i];
                        if (addedPageName.name === pageName.name) {
                            $scope.addedMenus[$scope.selectedLanguage][i] = pageName;
                            break;
                        }
                    }
                }
            }
        }
        initPageNames(preloadedPageNames);

        /**
         * Change menu item if it is not selected
         * @param menuItem
         */
        $scope.changeMenu = function (menuItem) {
            if (!$scope.activePage || menuItem.name !== $scope.activePage.name) {
                selectMenu(menuItem);
            }
        };

        function extractPosition(value) {
            if (value === undefined || value === '') {
                $scope.activePage.positionCustom = true;
                $scope.activePage.customPositionType = 'px';
                $scope.activePage.positionHorizontal = "";
                $scope.activePage.positionVertical = "";

                return;
            }
            if (value.match(/[0-9]/g)) {
                $scope.activePage.positionCustom = true;
                if (value.indexOf('px') > -1) {
                    $scope.activePage.customPositionType = 'px';
                } else if (value.indexOf('%') > -1) {
                    $scope.activePage.customPositionType = '%';
                }
                var values = value.replace(/%/g, "").replace(/px/g, "").split(" ");
                if (values.length === 2) {
                    $scope.activePage.positionHorizontal = values[0];
                    $scope.activePage.positionVertical = values[1];
                } else if (values.length === 1) {
                    $scope.activePage.positionHorizontal = values[0];
                    $scope.activePage.positionVertical = "";
                }

            } else {
                var values = value.split(" ");
                var horizontalMap = {
                    'left': true,
                    'right': true,
                    'center': true,
                };
                var verticalMap = {
                    'top': true,
                    'bottom': true,
                    'center': true
                };
                $scope.activePage.positionHorizontalRadio = horizontalMap[values[0]]? values[0]: 'left';
                $scope.activePage.positionVerticalRadio = (values.length > 1 && verticalMap[values[1]]) ? values[1]: 'top';
            }
            $scope.activePage.customPositionType =  $scope.activePage.customPositionType || 'px';
        }

        function extractCustomFields(customFields) {
            var customFieldsArray = customFields.children || customFields;
            var length = customFieldsArray.length;
            $scope.activePage.size = {};
            for (var i = 0; i < length; ++i){
                var customField = customFieldsArray[i];
                switch(customField.key) {
                    case 'position': {
                       extractPosition(customField.value);
                       break;
                    }
                    case 'size': {
                        $scope.activePage.customSizeType = 'px';

                        if (reversedBackgroundSize[customField.value]) {
                            $scope.activePage.size.type = reversedBackgroundSize[customField.value];
                        } else {
                            $scope.activePage.size.type = 'custom';
                            if (customField.value && customField.value.indexOf('%') > -1) {
                                $scope.activePage.customSizeType = '%';
                            }
                            $scope.activePage.size.size = customField.value.replace('%', '').replace('px', '');
                        }
                        break;
                    }
                    case 'color': {
                        $scope.activePage.color = customField.value;
                        $scope.activePage.isColorEditable = customField.value !== 'transparent';
                        break;
                    }
                    case 'attachment': {
                        $scope.activePage.attachment = customField.value;
                        break;
                    }
                }
            }
            $scope.activePage.size.type = $scope.activePage.size.type ||  backgroundPageDefaults.defaultBackgroundSizeType;
            $scope.activePage.color = $scope.activePage.color || backgroundPageDefaults.color;
            $scope.activePage.attachment =  $scope.activePage.attachment || $scope.backgroundAttachment[0];
            if (!length) {
                $scope.activePage.positionVerticalRadio = 'top';
                $scope.activePage.positionHorizontalRadio = 'left';
                $scope.activePage.customPositionType = 'px';
                $scope.activePage.positionCustom = false;
            }

        }

        /**
         * Select menu item
         * @param menuItem
         */
        function selectMenu(menuItem) {
            $scope.calledCount = 0;
            $scope.imageToLoad = null;
            $scope.draggedImageDataUrl = $scope.draggedImage = undefined;
            if (menuItem.page) {
                $scope.activePage = angular.copy(menuItem.page);
                $scope.activePage.isActive = $scope.activePage.status === 'published';
                $scope.initialBackgroundImage = $scope.activePage.image;
                extractCustomFields($scope.activePage.customFields);
                initialData = angular.copy($scope.activePage);
            } else {
                $scope.activePage = {
                    name: menuItem.name,
                    title: menuItem.title,
                    isActive: true,
                    image: "",
                    color: backgroundPageDefaults.color,
                    attachment: $scope.backgroundAttachment[0],
                    size: {
                        type:  backgroundPageDefaults.defaultBackgroundSizeType
                    },
                    customSizeType: 'px',
                    positionHorizontalRadio: 'left',
                    positionVerticalRadio: 'top',
                    positionCustom: false,
                    positionHorizontal: "",
                    positionVertical: "",
                    customPositionType: 'px',
                    isColorEditable: false
                };
            }
        };

        function initMenu(pages) {
            $scope.menu = [];
            var pagesLength = pages.length;
            var isSelected = false;
            for(var i = 0; i < pagesLength; ++i){
                var page = pages[i];
                var item = {};
                item.id =  page.id;
                item.title = pageNameTitleMap[page.name];
                item.page = page;
                item.name = page.name;
                $scope.menu.push(item);
                if ($scope.activePage && page.name === $scope.activePage.name) {
                    selectMenu(item);
                    isSelected = true;
                }
            }
            var addedMenuseLength = $scope.addedMenus[$scope.selectedLanguage]? $scope.addedMenus[$scope.selectedLanguage].length: 0;
            for (var j = 0; j < addedMenuseLength; ++j){
                var pageName = $scope.addedMenus[$scope.selectedLanguage][j];
                var item  = {};
                item.title = pageName.title;
                item.name = pageName.name;
                $scope.menu.push(item);
                if ($scope.activePage && !isSelected && pageName.name === $scope.activePage.name) {
                    selectMenu(item);
                    isSelected = true;
                }
            }
            $scope.menu.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            if (!isSelected) {
                if ($scope.menu.length === 0) {
                    $scope.activePage = undefined;
                } else {
                    selectMenu($scope.menu[0]);
                }
            }
        }
        initMenu(preloadedPages);

        /**
         * Update adding menu name chosen
         */
        $scope.updateAddingMenuChosen = function updateAddingMenuChosen() {
           $timeout(function () {
               $("#addingMenuName").trigger('chosen:updated');
           }, 50);
        };


        /**
         * Load selected language data
         */
        $scope.languageChangeHandler = function languageChangeHandler() {
            $scope.addmode = false;
            var filters = {
                lang: $scope.selectedLanguage,
                pageType: "backgrounds",
                page_id: 0
            };
            $rootScope.env.lang = $scope.selectedLanguage;
            Utils.saveEnvToStorage();
             pagesService.getPagesNames(filters).then(
                function (pageNamesResponse) {
                    initPageNames(pageNamesResponse);
                    var pageFilters = {
                        lang: $scope.selectedLanguage,
                        limit: 25,
                        type: "background"
                    };
                    pagesService.getPages(pageFilters).then(
                        function (pagesResponse) {
                           initMenu(angular.copy(pagesResponse.pages));
                            $scope.updateAddingMenuChosen();
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            );
        };


        /**
         * Add menu item
         */
        $scope.addMenu = function addMenu() {
            var pageNamesLength = $scope.pageNames.length;
            for(var i = 0; i < pageNamesLength; ++i) {
                var pageName = $scope.pageNames[i];
                if ($scope.addingMenuName === pageName.name) {
                    $scope.addedMenus[$scope.selectedLanguage] = $scope.addedMenus[$scope.selectedLanguage] || [];
                    $scope.addedMenus[$scope.selectedLanguage].push(pageName);
                    var item  = {};
                    item.title = pageName.title;
                    item.name = pageName.name;
                    $scope.menu.push(item);
                    break;
                }
            }
            $scope.menu.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            if (!$scope.activePage) {
                selectMenu($scope.menu[0]);
            }
            $scope.updateAddingMenuChosen();
            $scope.addingMenuName = "";
        };


        /**
         * Remove new added menu
         */
        $scope.removeMenu = function removeMenu(menu) {
            $scope.menu.splice($scope.menu.indexOf(menu), 1);
            $scope.addedMenus[$scope.selectedLanguage] = $scope.addedMenus[$scope.selectedLanguage].filter(function(item) {
                return item.name !== menu.name;
            });
            if ($scope.activePage.name === menu.name) {
                if($scope.menu.length > 0) {
                    selectMenu($scope.menu[0]);
                } else {
                    $scope.activePage = undefined;
                }
            }
            $scope.updateAddingMenuChosen();
        };

        /**
         * Delete background icon callback
         */
        $scope.deleteBackground = function deleteBackground() {
            $scope.activePage.image = false;
            $scope.imageToLoad = null;
            $scope.draggedImageDataUrl = $scope.draggedImage  = undefined;
        };


        /**
         *  Compute and return background size property
         */
        $scope.getBackgroundSize = function getBackgroundSize() {
            var result = "";
            if ($scope.activePage.size.type === 'custom') {
                result = $scope.activePage.size.size + $scope.activePage.customSizeType;
            } else {
               result =  backgroundPageDefaults.backgroundSize[$scope.activePage.size.type];
            }
            return result;
        };

        function getPosition() {
            var result = "";
            if ($scope.activePage.positionCustom) {
                if ($scope.activePage.positionHorizontal) {
                    result = $scope.activePage.positionHorizontal + $scope.activePage.customPositionType;
                }
                if ($scope.activePage.positionVertical) {
                    result += ' ' + $scope.activePage.positionVertical + $scope.activePage.customPositionType;
                }
            } else {
                if ($scope.activePage.positionHorizontalRadio) {
                    result = $scope.activePage.positionHorizontalRadio;
                }

                if ($scope.activePage.positionVerticalRadio) {
                    result += ' ' + $scope.activePage.positionVerticalRadio;
                }
            }
            return result;
        }
        
        function createAddRequestData(dataURL) {
            var requestData =  {
                title: $scope.activePage.title,
                name: $scope.activePage.name,
                status: $scope.activePage.isActive? "published": "archive",
                type: "background",
                lang: $scope.selectedLanguage,
                options: {
                    "size": $scope.getBackgroundSize(),
                    "position": getPosition(),
                    "attachment": $scope.activePage.attachment,
                    "color": $scope.activePage.color
                }
            };
            if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                requestData.media_id = $scope.imageToLoad.id;
            } else if (dataURL) {
                requestData.image = dataURL;
            }
            return [requestData];
        }

        function createEditRequestData(dataUrl) {
            var requestData = {
                id: $scope.activePage.id,
                title: $scope.activePage.title,
                name: $scope.activePage.name,
                status: $scope.activePage.isActive? "published": "archive",
                type: "background",
                lang: $scope.selectedLanguage,
                options: {
                    "size": $scope.getBackgroundSize(),
                    "position": getPosition(),
                    "attachment": $scope.activePage.attachment,
                    "color": $scope.activePage.color
                }
            };
            if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                requestData.media_id = $scope.imageToLoad.id;
            } else if (dataUrl && dataUrl.indexOf('data:image') > -1) {
                requestData.image =  dataUrl;
            }else if($scope.draggedImageDataUrl === undefined) {
                if($scope.initialBackgroundImage && !dataUrl) {
                    requestData.image = false;
                }
            }
            return [requestData];

        }

        function isChanged(){
            return ($scope.draggedImage && $scope.draggedImage.lastModified) || $scope.imageToLoad || !angular.equals($scope.activePage, initialData);
        }

        /**
         * Add or edit background page
         */
        $scope.save = function save() {

            if(!$scope.activePage.id) {
                pagesService.editPage(createAddRequestData($scope.activePage.image)).then(function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.saved");
                            $scope.addedMenus[$scope.selectedLanguage] =  $scope.addedMenus[$scope.selectedLanguage].filter(function (item) {
                                return item.name !== $scope.activePage.name;
                            });
                            $scope.languageChangeHandler();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                );
            } else {
                if (!isChanged()) {
                    logger.logError("global.no_changes");
                    return;
                } else {
                    pagesService.editPage(createEditRequestData($scope.activePage.image)).then(function (response) {
                            if (response.status == "ok") {
                                logger.logSuccess("global.saved");
                                var pageFilters = {
                                    lang: $scope.selectedLanguage,
                                    limit: 25,
                                    type: "background"
                                };
                                pagesService.getPages(pageFilters).then(
                                    function (pagesResponse) {
                                        var menuLength = $scope.menu.length;
                                        for (var i = 0; i < menuLength; ++i){
                                            var menu = $scope.menu[i];
                                            if (menu.name === $scope.activePage.name) {
                                                var pagesLength = pagesResponse.pages.length;
                                                for(var j = 0; j < pagesLength; ++j){
                                                    var page = pagesResponse.pages[j];
                                                    if(page.name === $scope.activePage.name) {
                                                        menu.page = page;
                                                        selectMenu(menu);
                                                        break;
                                                    }
                                                }
                                                break;
                                            }

                                        }
                                        $scope.updateAddingMenuChosen();
                                    },
                                    function (error) {
                                        errorHandler(error.message);
                                        return null
                                    }
                                )
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    );
                }
            }
        }


        $scope.$watch('activePage.positionCustom', function (newValue) {
            if (!$scope.activePage) {
                return;
            }
            if(newValue) {
                $scope.activePage.positionHorizontalRadio = "";
                $scope.activePage.positionVerticalRadio = "";
            }
        });

        $scope.$watch('activePage.positionHorizontalRadio', function () {
            if (!$scope.activePage) {
                return;
            }
            if ($scope.activePage.positionCustom && $scope.activePage.positionHorizontalRadio)  {
                $scope.activePage.positionCustom = false;
                $scope.activePage.positionVerticalRadio = 'top';
                $scope.activePage.positionHorizontal = "";
                $scope.activePage.positionVertical = "";
            }
        });

        $scope.$watch('activePage.positionVerticalRadio', function () {
            if (!$scope.activePage) {
                return;
            }
            if ($scope.activePage.positionCustom && $scope.activePage.positionVerticalRadio)  {
                $scope.activePage.positionCustom = false;
                $scope.activePage.positionHorizontalRadio = 'left';
                $scope.activePage.positionHorizontal = "";
                $scope.activePage.positionVertical = "";
            }
        });

        $scope.adjustColor = function adjustColor() {
            $scope.activePage.color = $scope.activePage.isColorEditable? '#000000': 'transparent';
        };


        $scope.load = function (dataUrl) {
            $scope.activePage.image = dataUrl;
            $timeout(function () {
                $scope.$apply();
            });
        };
        
        $scope.$on("image:uploaded", function () {
            $scope.imageToLoad = null;
        })


    }
]);
